import React, { FunctionComponent, useState } from 'react';
import StockLockContext from './StockLockContext';

const StockLockContextProvider: FunctionComponent = ({ children }) => {
  const [showStockLockModal, setShowStockLockModal] = useState(false);

  return (
    <StockLockContext.Provider
      value={{
        showStockLockModal,
        setShowStockLockModal,
      }}
    >
      {children}
    </StockLockContext.Provider>
  );
};

export default StockLockContextProvider;
